import { Button, Dialog, IconButton, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { extractErrorMessage } from '@/app/(blank-layout-pages)/(authenticated)/onboarding/errorHandling';
import { useWorkspace } from '@/contexts/useWorkspace';
import { runConfirmationAction, type ConfirmationActionProps } from './confirmationAction';
import { ButtonWithIcon } from '../buttons/buttonWithIcon';
interface ConfirmationDialogProps extends ConfirmationActionProps {
  isOpen: boolean;
  title: React.ReactNode;
  description: React.ReactNode;
  buttonIconClass?: string;
  buttonTitle: string;
  cancelButtonTitle?: string;
  confirmDisabled?: boolean;
}
export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const [error, setError] = useState('');
  const {
    snackbar
  } = useWorkspace();
  const [confirmationInProgress, setConfirmationProgress] = useState(false);
  const onConfirm = async () => {
    setError('');
    setConfirmationProgress(true);
    try {
      const failure = await runConfirmationAction(props, snackbar);
      if (failure) {
        setError(await extractErrorMessage(failure.error));
        window.reportError(failure.error);
      }
    } finally {
      setConfirmationProgress(false);
    }
  };

  // reset error message when dialog is closed
  useEffect(() => {
    if (props.isOpen) {
      setError('');
      setConfirmationProgress(false);
    }
  }, [props.isOpen]);
  return <Dialog open={props.isOpen} slotProps={{
    paper: {
      sx: {
        width: 'max-content',
        maxWidth: '840px',
        minWidth: '600px',
        height: 'max-content',
        maxHeight: '90vh',
        borderRadius: 'var(--mui-shape-customBorderRadius-lg)'
      }
    }
  }}>
      <Stack data-testid='confirmation-dialog'>
        <Stack direction='row' sx={{
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '16px 24px',
        paddingBottom: '0'
      }}>
          <div></div>
          <IconButton onClick={props.onCancel} sx={{
          color: 'var(--mui-palette-text-primary)'
        }}>
            <i className='material-symbols-close-rounded' />
          </IconButton>
        </Stack>
        <Stack sx={{
        alignItems: 'center',
        gap: '24px',
        px: '40px',
        textAlign: 'center',
        pb: '40px'
      }}>
          {typeof props.title === 'string' ? <Typography variant='h2'>{props.title}</Typography> : props.title}
          <Typography variant='body1' sx={{
          maxWidth: '70%',
          lineHeight: '20px'
        }}>
            {props.description}
          </Typography>
          <Stack direction='row' sx={{
          gap: '12px'
        }}>
            <Button onClick={props.onCancel}>
              {props.cancelButtonTitle ?? 'Cancel'}
            </Button>
            <ButtonWithIcon loading={confirmationInProgress} onClick={() => void onConfirm()} icon={props.buttonIconClass} text={props.buttonTitle} variant='outlined' disabled={props.confirmDisabled} />
          </Stack>
        </Stack>
        {error && <Typography variant='body1' sx={{
        color: 'error.main',
        padding: '0 0 16px 24px'
      }}>
            {error}
          </Typography>}
      </Stack>
    </Dialog>;
}